import React, { useRef, useState, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import "./Duckie.css";
import axios from "axios";

library.add(fab, faTimes);

const Duckie = ({ showModal, setShowModal }) => {
  const targetDuckieElement = useRef();
  const [data, setData] = useState({
    fullname: "",
    emailaddress: ""
  });
  const [formTextStatus, setFormTextStatus] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFail, setIsFail] = useState();
  const [isFormSubmit, setIsFormSubmit] = useState(false);

  function svgDuckieClose(e) {
    e.preventDefault();
    if (
      targetDuckieElement.current ||
      targetDuckieElement.current.contains(e.target)
    ) {
      targetDuckieElement.current.remove();
    }
  }
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleCloseModal = (e) => {
    setShowModal(false);
    setIsFormSubmit(false);
    setData({
      fullname: "",
      emailaddress: ""
    });
  };

  const handleInputData = (e) => {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
  };

  const submit = async (e) => {
    e.preventDefault();
    const query = new URLSearchParams(document.location.search)
    const regexEmail = /\S+@\S+\.\S+/;
    if (!regexEmail.test(data.emailaddress)) {
      setFormTextStatus("Please insert correct email address");
      setIsFail(true);
      setIsFormSubmit(true);
      return false;
    }
    setIsFormSubmit(false);
    setData({
      fullname: "",
      emailaddress: ""
    });

    if (!executeRecaptcha) {
      setFormTextStatus("Error : ReCaptcha not available");
      setIsFail(true);
      setIsFormSubmit(true);
      return;
    }

    try {

      const token = await executeRecaptcha("duckieSubmit")
      
      const resp = await axios.post("./newsletter_api.php", {
        email_address: data.emailaddress,
        full_name: data.fullname,
        utm_source: query.get('utm_source'),
        utm_medium: query.get('utm_medium'),
        utm_campaign: query.get('utm_campaign'),
        utm_term: query.get('utm_term'),
        utm_content: query.get('utm_content')
      });
      
      if (resp.status === 200) {
        setFormTextStatus("Thank you for filling in the form.");
        setIsSuccess(true);
        setIsFail(false);
        setIsFormSubmit(true);

        await axios.post("/mads/api/record/duckie", {
          email: data.emailaddress,
          name: data.fullname,
          token
        });
      } else {
        setFormTextStatus("Error : Something went wrong");
        setIsFail(true);
        setIsFormSubmit(true);
      }
    } catch (error) {
      setFormTextStatus("Error : Something went wrong with the request");
      setIsFail(true);
      setIsFormSubmit(true);
    }
  };

  useEffect(() => {
    showModal
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "inherit");
    setIsFormSubmit(false);
    setData({
      fullname: "",
      emailaddress: "",
    });
  }, [showModal]);

  return (
    <>
      <div className="parent-duckie" ref={targetDuckieElement}>
        <div className="relative child-duckie-container">
          <img src={require("../../Assets/duckie.png")} alt="duckie" />
          <div className="box firstbox relative text-white flex">
            <div className="relative duckie-container">
              <p>Join Taylor’s Duckie now!</p>
              {/* eslint-disable-next-line */}
              <a
                href="#"
                className="lightsub-ads"
                onClick={(e) => {
                  e.preventDefault();
                  setShowModal(true)
                }}
              >
                Register for Duckie Merch!
              </a>
            </div>
            <div className="relative">
              <FontAwesomeIcon
                className="svgDuckieCloseIcon"
                icon="times"
                onClick={svgDuckieClose}
              />
            </div>
          </div>
          <div className="box secondbox"></div>
        </div>
      </div>
      {showModal ? (
        <>
          <div
            className="relative z-10"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <form
                  className="space-y-3"
                  action="#"
                  method="POST"
                  onSubmit={(e) => submit(e)}
                  enctype="multipart/form-data"
                >
                  <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="-space-y-px rounded-md">
                        <h2 className="mb-6 text-center text-2xl font-bold tracking-tight text-gray-900">
                          Register your spot for Taylor’s Duckie to redeem exclusive merchandise!
                        </h2>
                        {isFormSubmit ? (
                          <>
                            {isFail ? (
                              <div
                                className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                                style={{ marginBottom: "20px" }}
                              >
                                <span className="block sm:inline">
                                  {formTextStatus}
                                </span>
                              </div>
                            ) : (
                              <div
                                className="bg-blue-100 border border-blue-500 px-4 py-3 rounded relative"
                                style={{ marginBottom: "20px" }}
                              >
                                <span className="block sm:inline">
                                  {formTextStatus}
                                </span>
                              </div>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                        {isSuccess ? (
                          <></>
                        ) : (
                          <>
                            <div>
                              <label htmlFor="full-name" className="sr-only">
                                Preferred Name
                              </label>
                              <input
                                id="fullname"
                                name="fullName"
                                type="text"
                                required
                                className="relative block w-full appearance-none border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm mb-5"
                                placeholder="Preferred Name"
                                onChange={(e) => handleInputData(e)}
                                value={data.fullname}
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="email-address"
                                className="sr-only"
                              >
                                Email address
                              </label>
                              <input
                                id="emailaddress"
                                name="email"
                                type="email"
                                required
                                className="relative block w-full appearance-none border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm mb-5"
                                placeholder="Email address"
                                onChange={(e) => handleInputData(e)}
                                value={data.emailaddress}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      {isSuccess ? (
                        <></>
                      ) : (
                        <>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              <i>
                                * TMC More Than Just Music tickets have to be purchased separately 
                                {'   '}
                                <a 
                                  href="https://tmc.quintagen.com/"
                                  target="_blank"
                                  className="text-cyan-500"
                                  rel="noreferrer"
                                >
                                  here
                                </a>
                                .
                              </i>
                              <br />
                              <i>
                                ** By clicking submit, you agree to Taylor's{' '}
                                <a
                                  href="https://university.taylors.edu.my/en/terms-conditions.html"
                                  target="_blank"
                                  className="text-cyan-500"
                                  rel="noreferrer"
                                >
                                  Terms and Conditions
                                </a>
                                ,{' '}
                                <a 
                                  href="https://university.taylors.edu.my/en/privacy-policy.html"
                                  target="_blank"
                                  className="text-cyan-500"
                                  rel="noreferrer"
                                >
                                  Privacy Policy
                                </a>
                                {' '}and receiving event updates and newsletters from Taylor’s Duckie Team.
                              </i>
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      {isSuccess ? (
                        <></>
                      ) : (
                        <>
                          <button
                            type="submit"
                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                          >
                            Submit
                          </button>
                        </>
                      )}
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={handleCloseModal}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default Duckie;
